import React from 'react';
import { useRecoilValue } from 'recoil';
import { isAdminState, isTQAdminState } from '../../store';
import { UnAuthorised } from '../../pages';

export const ConsulteeAdminProvider: React.FC = ({ children }) => {
  const isConsulteeAdmin = useRecoilValue(isAdminState);
  const isTQAdmin = useRecoilValue(isTQAdminState);
  return isConsulteeAdmin || isTQAdmin ? <>{children}</> : <UnAuthorised />;
};
